/**
 * `GET /api/onboarding/team` — what a JOINED user's team already has, for the one line on their
 * welcome ("Tu equipo ya tiene 12 documentos y 3 clientes", MAR-933 F1).
 *
 * WHY A SEPARATE ENDPOINT (tester book r2, perf). The counts used to ride on the profile's one-time
 * evaluation, which runs on EVERY `/api/profile` read until the user enters onboarding — measured at
 * +30–45 ms per read against an org with 200k documents, where the old `LIMIT 1` existence check cost
 * 0.02 ms. The evaluation is back to existence checks, and the exact numbers are asked for once, by the
 * welcome screen, only while a joined user is looking at it. Everybody else never pays for them.
 *
 * CAPPED. Each count reads at most `TEAM_COUNT_CAP + 1` rows, so its cost stops growing with the org:
 * a value above the cap means "more than the cap" and the welcome shows it as "1000+".
 */
export const TEAM_COUNT_CAP = 1000

/** By the same definitions as the evaluation's `has_*`; each value is at most `TEAM_COUNT_CAP + 1`. */
export interface OnboardingTeamCounts {
  documents: number
  clients: number
  cases: number
}

export interface OnboardingTeamResponse {
  /**
   * `null` for anyone the line is not for: a user who founded the org, who has already entered
   * onboarding, or a superadmin acting as another organization.
   */
  counts: OnboardingTeamCounts | null
}
